import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import clsx from 'clsx';
import styles from './SubModuleHeader.style';
import { useSubModuleContext } from '../../context/sub-module';

const SubModuleHeader = ({ id, variant, extra, children, className: classNameProp, ...other }) => {
  const { toggleIsOpen, isOpen, disableAccordian } = useSubModuleContext();
  const asMap = {
    medium: 'h4',
    large: 'h3',
    xLarge: 'h2',
  };
  const expandable = disableAccordian === false;

  const className = clsx(styles.root, classNameProp, {
    [styles.isOpen]: isOpen,
  });

  const handleClick = () => {
    if (expandable) {
      toggleIsOpen();
    }
  };

  return (
    <Text as={asMap[variant]} id={id} className={className} onClick={handleClick} {...other}>
      <span>{children}</span>
      <div>
        {extra}
        {expandable && (
          <IconButton
            iconProps={{ iconName: isOpen ? 'ChevronUpMed' : 'ChevronDownMed' }}
            aria-labelledby={id}
            aria-hidden="false"
            onClick={handleClick}
            aria-expanded={isOpen}
            className={styles.icon}
            tabIndex="0"
          />
        )}
      </div>
    </Text>
  );
};

SubModuleHeader.propTypes = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf(['medium', 'large', 'xLarge']),
  extra: PropTypes.node,
  className: PropTypes.string,
  id: PropTypes.string,
};

SubModuleHeader.defaultProps = {
  variant: 'medium',
  extra: null,
  className: '',
  id: '',
};

export default SubModuleHeader;
